<main class="main-container">

    <div class="bg-th-yellow mt-0 container-fluid">

        <div class=" d-flex justify-content-between align-content-center h-35">
      
          <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>
      
          <span class="my-auto f16 fw-bold me-2"> برنامه سفرهای رانندگان  </span>
      
        </div>
      
    </div>

    <section class="w-100 row gx-0 gy-0 p-2" style="direction: rtl;">

        <div [formGroup]="mdl_Search" class="container-fluid row gx-2 gy-2 p-2">

            <!-- از تاریخ -->

            <div class="col-12 col-md-2 position-relative mb-md-0 mb-2">

                <label> از تاریخ </label>
    
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                    [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                    <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />
    
                </ng-persian-datepicker>
    
            </div>

            <!-- تا تاریخ -->

            <div class="col-12 col-md-2 position-relative">

                <label> تا تاریخ </label>
    
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                    [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                    <input type="text" formControlName="strEDate" placeholder="تا تاریخ" class="form-control text-end" />
    
                </ng-persian-datepicker>
    
            </div>

            <!-- جستجو -->

            <div class="col-12 col-md-auto position-relative">

                <button class="btn btn-primary w-100" (click)="search_Drivers()"> 

                    جستجو
                    
                </button>

            </div>

            <!-- محتوای جدول -->

            <div class="col-12 border border-2 mt-3 p-2">

                <input type="text" class="w-100 form-control my-3" placeholder="جستجو کنید ..." >

                <div class="col-12 section border border-2 mt-2" style="height:calc(100vh - 210px);overflow: auto;">

                    <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        
                        <thead class="">
    
                            <tr class="">
    
                                <th class="text-center col-1"> # </th>

                                <th class="text-center"> شهر مبداء </th>

                                <th class="text-center"> تاریخ </th>

                                <th class="text-center"> ساعت </th>

                                <th class="text-center"> گروه خودرویی </th>
        
                                <th class="text-center"> نوع خودرو </th>
    
                                <th class="text-center"> نام خودرو </th>
        
                                <th class="text-center"> نام راننده </th>
                                
                                <th class="text-center"> موبایل </th>
                    
                                <th class="text-center"> سرویس&zwnj;ها </th>
    
                                <th class="text-center"> لغو&zwnj;ها </th>
    
                            </tr>
        
                        </thead>
        
                        <tbody class="">
        
                            <tr class="col-12 text-center" *ngFor="let item of lst_Drivers;let i = index">
    
                                <td>{{ i + 1 | faNum }}</td>

                                <td> {{ item.strCityName | faNum }} </td>

                                <td> {{ item.strDate | faNum }} </td>

                                <td> {{ item.strSTime | faNum }} </td>

                                <td> {{ item.strMobileGroup_strComment | faNum }} </td>
    
                                <td> {{ item.strMobileType_strComment | faNum }} </td>
    
                                <td> {{ item.strGPSType_strComment | faNum }} </td>
    
                                <td> {{ item.strFullName | faNum }} </td>
                                
                                <td> {{ item.strMobile | faNum }} </td>
                                                                    
                                <td> {{ item.iTrip | faNum }} </td>
    
                                <td> {{ item.iCancel | faNum }} </td>
                                        
                            </tr>
        
                        </tbody>
        
                    </table>
        
                </div>

            </div>

        </div>

    </section>

</main>